import { UploadPublicImageEntity, ContentType } from '@seaters/constants';
import { api } from '../axios-instance';

// New public image upload using files module
export const createPublicUploadURL = async (
  contentType: ContentType
): Promise<{
  url: string;
  key: string;
}> => {
  return api.post('/files/upload-url', {
    contentType,
    access: 'public-read',
  });
};

export const uploadPublicImage = async (
  formData: FormData,
  progressCallback: (progress: number) => void
): Promise<UploadPublicImageEntity> => {
  const file = formData.get('file') as File;
  if (!file) throw new Error('No file provided');

  // Create upload URL
  const { url, key } = await createPublicUploadURL(file.type as ContentType);

  // Upload file with progress tracking
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        const progress = Math.round((event.loaded / event.total) * 100);
        progressCallback(progress);
      }
    });

    xhr.addEventListener('load', () => {
      if (xhr.status === 200) {
        // Return the public URL - assuming the key becomes the public URL
        resolve({ url: key, key });
      } else {
        reject(new Error(`Upload failed with status ${xhr.status}`));
      }
    });

    xhr.addEventListener('error', () => {
      reject(new Error('Upload failed'));
    });

    xhr.open('PUT', url);
    xhr.send(file);
  });
};
